import React from "react";

import {
  FaChartLine,
  FaCoins,
  FaProjectDiagram,
  FaUserShield,
  FaRocket,
  FaSlidersH,
} from "react-icons/fa";

function OurProcess() {
  const reasons = [
    {
      title: "Spot, Margin & Futures Trading",
      desc: "Empower your users with a comprehensive suite of trading options, including spot, margin, and futures trading, allowing them to maximize their investment strategies and navigate market fluctuations with confidence.",
      icon: <FaChartLine size={35} />,
    },
    {
      title: "Unlimited Crypto Assets Support",
      desc: "Offer an extensive range of cryptocurrencies to meet the diverse needs of your users, ensuring they can trade popular coins as well as emerging tokens, all from a single, easy-to-use platform.",
      icon: <FaCoins size={35} />,
    },
    {
      title: "Easy New Blockchain Integration",
      desc: "Seamlessly integrate new blockchain technologies to expand your exchange’s capabilities, enabling support for the latest tokens and decentralized applications, enhancing your platform's competitiveness in the ever-evolving crypto landscape.",
      icon: <FaProjectDiagram size={35} />,
    },
    {
      title: "KYC & AML Window",
      desc: "Implement robust security measures with our integrated Know Your Customer (KYC) and Anti-Money Laundering (AML) features, ensuring compliance with regulatory standards while protecting your platform and users from fraudulent activities.",
      icon: <FaUserShield size={35} />,
    },
    {
      title: "Staking & Launchpad",
      desc: "Engage your user base with enticing staking options that provide passive income opportunities, alongside a dedicated launchpad for new tokens, facilitating initial coin offerings (ICOs) and attracting innovative projects to your exchange.",
      icon: <FaRocket size={35} />,
    },
    {
      title: "Custom Trading Window",
      desc: "Enhance the user experience with a fully customizable trading window, allowing users to personalize their layout, choose preferred trading pairs, and access advanced tools that cater to their unique trading styles.",
      icon: <FaSlidersH size={35} />,
    },
  ];
  return (
    <>
      <div
        className="services-area pt-120 pb-120"
        style={{ background: "#ffffff" }}
      >
        <div className="container text-center">
          <h2
            className="title  mb-4"
            // style={{ fontSize: "40px", letterSpacing: "-1px" }}
          >
            Elevate your exchange with our ready-to-use white label crypto
            exchange software
          </h2>

          <p
            className="mt-2 mb-5 mx-auto text-muted fs-5"
            style={{ maxWidth: "800px" }}
          >
            Transform your vision into a fully branded crypto exchange with our
            customizable, user-friendly platform, ready for instant deployment
            and seamless scalability.
          </p>

          <div className="row g-4 justify-content-center">
            {reasons.map((reason, index) => (
              <div className="col-lg-4 col-md-6" key={index}>
                <div
                  className="reason-card border-0 p-5 text-center h-100"
                  style={{
                    borderRadius: "32px",
                    background: "#f9faff",
                    border: "1px solid #f0f3ff",
                    transition: "all 0.4s ease",
                    cursor: "default",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-10px)";
                    e.currentTarget.style.background = "#ffffff";
                    e.currentTarget.style.boxShadow =
                      "0 25px 50px rgba(0, 0, 0, 0.04)";
                    e.currentTarget.style.borderColor = "#3366ff20";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.background = "#f9faff";
                    e.currentTarget.style.boxShadow = "none";
                    e.currentTarget.style.borderColor = "#f0f3ff";
                  }}
                >
                  <div
                    className="icon-box mx-auto d-flex align-items-center justify-content-center mb-4"
                    style={{
                      width: "70px",
                      height: "70px",
                      fontSize: "28px", // untouched
                      backgroundColor: "#ffffff",
                      color: reason.color,
                      borderRadius: "20px",
                      boxShadow: "0 10px 20px rgba(0,0,0,0.03)",
                    }}
                  >
                    {reason.icon}
                  </div>

                  <h5 className="fw-bold mb-3" style={{ fontSize: "18px" }}>
                    {reason.title}
                  </h5>

                  <p
                    style={{
                      fontSize: "14px",
                      color: "#6c757d",
                      lineHeight: "1.7",
                      marginBottom: 0,
                    }}
                  >
                    {reason.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default OurProcess;
